export function eventNamespaceFactory(namespace: string) {
	return (element: EventTarget, eventName: string): boolean =>
		element.dispatchEvent(new CustomEvent(eventName + '.' + namespace));
}
